import type { FaireProductEntity } from "../../entity_types/product";

export const p_3aanrztb5q: FaireProductEntity = {
  token: "p_3aanrztb5q",
  type: "product",
  name: "Birthday Bouqet Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/7edf1f2bfb001482be3cb03beb594e56419fe242eec24682a6397adc618031a7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/572076cb1e59302ad6c45afed6d08328811361b6eaf824e6a15b3a562858c18c.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:29.415Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
